import { useBehaviorSubject } from '@base/utils/helpers';
import { MessagesService } from '@base/features/chat/messagesService';
import { container } from 'tsyringe';
import React, { useState } from 'react';
import { Message } from '../message';
import { IPlayersOnlineRepository } from '@base/features/player/model/interfaces';
import { IUserService } from '@base/features/user/model/interfaces';
import { MAIN_ROUTES } from '@base/features/routing/constants/mainRoutes';
import { useHistory } from 'react-router-dom';

type UseTableType = {
  message: string;
  messages: Message[] | undefined;
  handleMessage: (e: React.ChangeEvent<HTMLInputElement>) => void;
  sendMessage: (e: React.FormEvent<HTMLFormElement>) => void;
  handleEmoji: (emoji: string) => void;
  joinPrivatChat(playerId?: number): void;
};

export const useTableChat = (): UseTableType => {
  const messagesService: MessagesService = container.resolve('messagesService');
  const playersOnlineRepository: IPlayersOnlineRepository = container.resolve('playersOnlineRepository');
  const table = playersOnlineRepository.me?.getTable();
  const history = useHistory();
  const messages = useBehaviorSubject<Message[]>(table!.onChatMessages);
  const userService: IUserService = container.resolve('userService');
  const [message, setMessage] = useState('');

  function handleMessage(e: React.ChangeEvent<HTMLInputElement>): void {
    setMessage(e.target.value);
  }

  function handleEmoji(emoji: string) {
    setMessage((prevState) => `${prevState} ${emoji} `);
  }

  function sendMessage(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    if (!message.length) return;
    if (!table?.tid) return;

    if (userService.isGuestPlayer())
      return userService.openGuestModal(() => history.push(MAIN_ROUTES.register));

    messagesService.sendMessageOnTable(message, table.tid);
    setMessage('');
  }

  function joinPrivatChat(playerId?: number): void {
    if (!playerId || playerId === playersOnlineRepository.me?.getPid()) return;
    const player = playersOnlineRepository.getPlayerOnline(playerId);
    player && messagesService.joinPrivatChat(player);
  }

  return {
    message,
    messages,
    handleMessage,
    sendMessage,
    handleEmoji,
    joinPrivatChat,
  };
};
